import React from 'react';

type WordFileIconProps = { width?: string; height?: string };
function WordFileIcon({ width = '50', height = '66' }: WordFileIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 50 66'
      fill='none'
    >
      <path d='M50 22H0V44H50V22Z' fill='url(#paint0_linear_2100_9346)' />
      <path
        d='M50 44H0V58C0 62.4183 3.58172 66 8 66H42C46.4183 66 50 62.4183 50 58V44Z'
        fill='url(#paint1_linear_2100_9346)'
      />
      <path
        d='M42 0H8C3.58172 0 0 3.58172 0 8V22H50V8C50 3.58172 46.4183 0 42 0Z'
        fill='url(#paint2_linear_2100_9346)'
      />
      <path
        d='M37 20.1875H15.125C13.3991 20.1875 12 21.5866 12 23.3125V45.1875C12 46.9134 13.3991 48.3125 15.125 48.3125H37C38.7259 48.3125 40.125 46.9134 40.125 45.1875V23.3125C40.125 21.5866 38.7259 20.1875 37 20.1875Z'
        fill='black'
        fill-opacity='0.51'
      />
      <path
        d='M34 17H12.125C10.3991 17 9 18.3991 9 20.125V42C9 43.7259 10.3991 45.125 12.125 45.125H34C35.7259 45.125 37.125 43.7259 37.125 42V20.125C37.125 18.3991 35.7259 17 34 17Z'
        fill='#224B89'
      />
      <path
        d='M32.75 23.0222H29.7067L27.317 33.2172L24.7026 23H22.1291L19.4943 33.2172L17.125 23.0222H14L18.0645 38.625H20.7606L23.375 28.7623L25.9894 38.625H28.6855L32.75 23.0222Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_2100_9346'
          x1='21.875'
          y1='34.5714'
          x2='50'
          y2='34.5714'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#20478B' />
          <stop offset='1' stop-color='#2D6FD1' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2100_9346'
          x1='0'
          y1='57.75'
          x2='50'
          y2='57.75'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#1B366F' />
          <stop offset='1' stop-color='#2657B0' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2100_9346'
          x1='21.875'
          y1='12.5714'
          x2='50'
          y2='12.5714'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#215295' />
          <stop offset='1' stop-color='#2E84D3' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default WordFileIcon;
